import { render, staticRenderFns } from "./ElectronicDocumentMovements.vue?vue&type=template&id=51a9f489"
import script from "./ElectronicDocumentMovements.vue?vue&type=script&lang=js"
export * from "./ElectronicDocumentMovements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports